<template>
    <div>
        <h1 class="display-heading mb-3">Patient Queue</h1>

        <table ref="listTable" class="table table-sm table-hover">
            <colgroup>
                <col width="50" />
                <col width="150" />
                <col />
                <col width="150" />
                <col width="150" />
                <col width="80" />
                <col width="350" />
            </colgroup>
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Time In</th>
                    <th>Full Name</th>
                    <th>IC Number</th>
                    <th>Phone Number</th>
                    <th>Status</th>
                    <th>Action</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(q, i) in queueList" :key="i">
                    <td>
                        {{ i + 1 }}
                    </td>
                    <td>{{ q.timeIn }}</td>
                    <td>
                        {{ q.patientName }}
                    </td>
                    <td>
                        {{ q.patientIcNumber ? q.patientIcNumber : "-" }}
                    </td>
                    <td>
                        {{ q.patientPhoneNumber ? q.patientPhoneNumber : "-" }}
                    </td>
                    <td>
                        <span
                            class="badge text-nowrap"
                            :class="q.statusBadgeClass"
                            >{{ q.statusDisplay }}</span
                        >
                    </td>
                    <td>
                        <template v-if="q.status === 1">
                            <button
                                v-if=" !isNurse"
                                type="button"
                                class="btn btn-sm btn-primary btn-primary-insv mr-2"
                                @click="goToConsultation(q.queueId)"
                            >
                                Consult Now
                            </button>
                            <button
                                type="button"
                                class="btn btn-sm btn-danger"
                                @click="cancelQueue(q.queueId)"
                            >
                                Cancel Queue
                            </button>
                        </template>
                        <template v-else-if="q.status===2 && !isNurse">
                             <button
                                type="button"
                                class="btn btn-sm btn-primary btn-primary-insv mr-2"
                                @click="continueConsultation(q.queueId)"
                            >
                                Continue Consultation
                            </button>
                            <button
                                type="button"
                                class="btn btn-sm btn-danger"
                                @click="cancelQueue(q.queueId)"
                            >
                                Cancel Queue
                            </button>
                        </template>
                        <template v-else-if="q.status===3 && !isNurse">
                             <button
                                type="button"
                                class="btn btn-sm btn-primary btn-primary-insv mr-2"
                                @click="continueConsultation(q.queueId)"
                            >
                                Review Payment Details
                            </button>
                        </template>
                    </td>
                </tr>
                <tr v-if="queueList.length === 0">
                    <td class="text-center" colspan="7">
                        No patient in queue.
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { convertToUserReadableDateTime } from '@/utilities';

import {
    clinicQueueStatus,
    getEnumDisplay,
    getEnumBadgeClass
} from '@/config/enums';

export default {
    'name': 'PatientQueue',
    'computed': {
        isNurse () {
            if (this.$store.state.user.userRole === 7) {
                return true;
            } else {
                return false;
            }
        }
    },
    data () {
        return {
            'queueList': [],
            'apiInterval': null
        };
    },
    mounted () {
        this.getQueue();

        this.apiInterval = setInterval(() => {
            this.getQueue();
        }, 10000);
    },
    destroyed () {
        clearInterval(this.apiInterval);
    },
    'methods': {
        getQueue () {
            this.axios.get('Clinic/GetQueue').then(({ data }) => {
                let list = data.data;

                this.queueList = list.map((queue) => ({
                    'queueId': queue.queueId,
                    'timeIn': convertToUserReadableDateTime(queue.createdTime),
                    'patientIcNumber': queue.patientIcNumber,
                    'patientName': queue.patientName,
                    'patientPhoneNumber': queue.patientPhoneNumber,
                    'status': queue.status,
                    'statusDisplay': getEnumDisplay(
                        clinicQueueStatus,
                        queue.status
                    ),
                    'statusBadgeClass': getEnumBadgeClass(
                        clinicQueueStatus,
                        queue.status
                    )
                }));
            });
        },
        cancelQueue (queueId) {
            this.axios.post('Clinic/CancelQueue', {
                'queueId': queueId
            }).then(() => {
                this.getQueue();
            });
        },
        goToConsultation (queueId) {
            this.axios.post('Clinic/StartConsultation', {
                'queueId': queueId
            }).then(() => {
                this.$router.push({
                    'name': 'clinic-consultation-details',
                    'params': {
                        'id': queueId
                    }
                });
            });
        },
        continueConsultation (queueId) {
            this.$router.push({
                'name': 'clinic-consultation-details',
                'params': {
                    'id': queueId
                }
            });
        }
    }
};
</script>

<style>
</style>
